import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserEntity } from 'src/app/core/_models/userEntity';

@Component({
  selector: 'app-dialog-fusion-user-entity',
  templateUrl: './dialog-fusion-user-entity.component.html',
  styleUrls: ['./dialog-fusion-user-entity.component.scss']
})
export class DialogFusionUserEntityComponent {
  newEu: any = {
    euIdsToFusion: [],
    memberId: null
  };

  constructor(
    public dialogRef: MatDialogRef<DialogFusionUserEntityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.memberId) this.newEu.memberId = data.memberId;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  changeCheckBox(event: any, eu: UserEntity) {
    if (eu?.euId) {
      event?.checked ? this.newEu?.euIdsToFusion.push(eu?.euId) : this.newEu?.euIdsToFusion.splice(this.newEu?.euIdsToFusion.indexOf(eu?.euId), 1);
    }
  }
}
